import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import '@fontsource/fahkwang/300.css'
import '@fontsource/fahkwang/400.css'
import '@fontsource/fahkwang/500.css'
import '@fontsource/fahkwang/600.css'
import '@fontsource/fahkwang/700.css'
import { queryClient } from './lib/queryClient'
import { SessionProvider, useSession } from './contexts/SessionContext'
import { LoginPage } from './components/LoginPage'
import { ThemeProvider } from './components/wondercare'
import {
  installChunkErrorHandler,
  clearChunkReloadFlag,
} from './lib/lazy-with-reload'
import './index.css'
import App from './App.tsx'

// Recovers from stale-chunk errors after a deploy: catch failing dynamic
// imports + module-preload failures and force a single full reload so the
// user picks up the new bundle.
installChunkErrorHandler()
clearChunkReloadFlag()

function AuthenticatedApp() {
  const { status } = useSession();

  if (status === 'bootstrapping' || status === 'loadingProfile') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (status !== 'authenticated') {
    return <LoginPage />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider defaultTheme="system">
      <SessionProvider>
        <AuthenticatedApp />
      </SessionProvider>
    </ThemeProvider>
  </StrictMode>,
)
